import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { doGetPartnerOrders } from './thunk';

const partnerOrdersAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const partnerOrderSlice = createSlice({
  name: 'partnerOrder',
  initialState: {
    action: null,
    isFetching: false,
    status: 'idle',
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetPartnerOrders.pending, (state) => {
      state.action = 'getall';
      state.status = 'loading';
      state.isFetching = true;
    });
    builder.addCase(doGetPartnerOrders.fulfilled, (state, action) => {
      const { orders, pagination } = action.payload;
      state.status = 'succeeded';
      state.metadata = pagination;
      state.isFetching = false;
      partnerOrdersAdapter.setAll(state, orders);
    });
    builder.addCase(doGetPartnerOrders.rejected, (state) => {
      state.status = 'failed';
      state.isFetching = false;
      partnerOrdersAdapter.setAll(state, []);
    });
  },
});

export const {
  selectAll: selectAllPartnerOrders,
  selectById: selectPartnerOrderById,
  selectIds: selectPartnerOrderIds,
} = partnerOrdersAdapter.getSelectors((state) => state.partnerOrder);

const { reducer: PartnerOrderReducer } = partnerOrderSlice;
export default PartnerOrderReducer;
